import { render } from "./FrontPage.vue?vue&type=template&id=f70b9514&ts=true"
import script from "./FrontPage.vue?vue&type=script&lang=ts"
export * from "./FrontPage.vue?vue&type=script&lang=ts"

import "./FrontPage.vue?vue&type=style&index=0&id=f70b9514&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__